export default __webpack_public_path__ + "locales/tr/DeleteThirdPartyDialog.json?hash=00f8c81224f48b8d790f6ee8809bb9a1";